import React from 'react'
import {calculateTimestamp} from './timestamp'
import {apiVariables} from './variables';



export class ScheduleEditor extends React.Component{
    constructor(props){
        super(props);
        if(this.props.event.months === null){this.props.event.months = ""}
        if(this.props.event.daysOfMonth === null){this.props.event.daysOfMonth = ""}
        if(this.props.event.daysOfWeek === null){this.props.event.daysOfWeek = ""}
        if(this.props.event.hours === null){this.props.event.hours = ""}
        if(this.props.event.minutes === null){this.props.event.minutes = ""}
        this.state = {months: this.props.event.months,
                      daysOfMonth: this.props.event.daysOfMonth,
                      daysOfWeek: this.props.event.daysOfWeek,
                      daysOfWeekArray: generateDayArray(this.props.event.daysOfWeek),
                      hours: this.props.event.hours,
                      minutes: this.props.event.minutes,
                      errorMessages: []}
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.finishChanges = this.finishChanges.bind(this);
        this.handleSelect = this.handleSelect.bind(this);


    }
    handleChange(e){
        let regex = /^([0-9]+(,[0-9]+)*,?)*$/;
        if(regex.test(e.target.value)){
            this.setState({[e.target.name]: e.target.value});
        }
    }
    handleSelect(e){
        let tempState = this.state.daysOfWeekArray;
        let stringbuilder = "";
        let none = false;
        
        for(let i in e.target.options){
            if(e.target.options[i].value === "none" && e.target.options[i].selected){
                none = true;
            }
            if(e.target.options[i].value !== undefined){
                if(none === true){
                    tempState[parseInt(e.target.options[i].value[0]) - 1] = false;
                }
                else if(e.target.options[i].selected){
                    stringbuilder += e.target.options[i].value;
                    tempState[parseInt(e.target.options[i].value[0]) - 1] = true;
                }
                else{
                    tempState[parseInt(e.target.options[i].value[0]) - 1] = false;
                }
            }
        }
        
        console.log(stringbuilder);
        this.setState({daysOfWeek: stringbuilder.slice(0, -1)});
    }
    render(){ 
        return (
            <div className="col-md-12">
                <div className="col-md-2"></div>
                <form onChange={this.handleChange} className="col-md-8">
                    <div className="form-group row">
                        <div className="col-md-2">
                            <label>Months:</label>
                        </div>
                        <div className="col-md-10">
                            <input className="form-control" type="text" defaultValue={this.state.months} name="months" />
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="col-md-2">
                            <label>Days Of Month:</label>
                        </div>
                        <div className="col-md-10">
                            <input className="form-control" type="text" defaultValue={this.state.daysOfMonth} name="daysOfMonth" />
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="col-md-2">
                            <label>Days Of Week:</label>
                        </div>
                        <div className="col-md-10">
                            <select multiple className="form-control" onChange={this.handleSelect}>
                                <option value="none"> --- None ---</option>
                                <option value="1," selected={this.state.daysOfWeekArray[0]}>Sunday</option>
                                <option value="2," selected={this.state.daysOfWeekArray[1]}>Monday</option>
                                <option value="3," selected={this.state.daysOfWeekArray[2]}>Tuesday</option>
                                <option value="4," selected={this.state.daysOfWeekArray[3]}>Wednesday</option>
                                <option value="5," selected={this.state.daysOfWeekArray[4]}>Thursday</option>
                                <option value="6," selected={this.state.daysOfWeekArray[5]}>Friday</option>
                                <option value="7," selected={this.state.daysOfWeekArray[6]}>Saturday</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="col-md-2">
                            <label>Hours:</label>
                        </div>
                        <div className="col-md-10">
                            <input className="form-control" type="text" defaultValue={this.state.hours} name="hours" />
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="col-md-2">
                            <label>Minutes:</label>
                        </div>
                        <div className="col-md-10">
                            <input className="form-control" type="text" defaultValue={this.state.minutes} name="minutes" />
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="col-md-2">
                        </div>
                        <div className="col-md-2">
                            <button type="button" className="btn btn-success" onClick={this.handleSubmit}>Submit</button>
                        </div>
                    </div>
                    
                    {this.state.errorMessages}
                </form>
                <div className="col-md-2"></div>
            </div>
        );
    }
   
    handleSubmit(){
        let tempMessage = this.handleCheck();
        if(tempMessage.length === 0){
            this.finishChanges(calculateTimestamp(this.state));
        }
        this.setState({errorMessages: tempMessage})
    }
    finishChanges(timestamp){
        let that = this;
        fetch( apiVariables.apiLink + 'solutionmonitor/event?organization='
        + encodeURIComponent(this.props.CurrentOrganization) + '&eventName=' + encodeURIComponent(this.props.event.eventName) + '&solutionName=' + encodeURIComponent(this.props.event.solutionName) +
        stringConstructor(timestamp, this.state.months, this.state.daysOfMonth, this.state.daysOfWeek, this.state.hours, this.state.minutes) + '&eventHappened=FALSE&passedDeadline=FALSE', { 
        method: 'PUT',
        headers: apiVariables.apiHeader,
        credentials: apiVariables.credentials
        }).then(function(response){
            console.log(response);
            if(response.status === 202){
                that.setState({errorMessages: [<div key="successMessage" className="alert alert-success col-md-12"><strong>Success!</strong> event successfully updated</div>]})
                that.props.refresh();
            }
            else{
                that.setState({errorMessages: [<div key="errorMessage" className="alert alert-danger col-md-12"><strong>Erro: </strong> {response.statusText}</div>]})
            }
        })
        

    }
    handleCheck(){
        let Message = []
        let tempMonths = this.state.months.split(',').map(Number);
        if(tempMonths.length === 1 && tempMonths[0] === 0){ tempMonths = []}
        let tempDaysOfMonth = this.state.daysOfMonth.split(',').map(Number);
        if(tempDaysOfMonth.length === 1 && tempDaysOfMonth[0] === 0){ tempDaysOfMonth = []}
        let tempDaysOfWeek = this.state.daysOfWeek.split(',').map(Number);
        if(tempDaysOfWeek.length === 1 && tempDaysOfWeek[0] === 0){ tempDaysOfWeek = []}
        let tempHours = this.state.hours.split(',').map(Number);
        if(tempHours.length === 1 && tempHours[0] === 0){ tempHours = []}
        let tempMinutes = this.state.minutes.split(',').map(Number);
        if(tempMinutes.length === 1 && tempMinutes[0] === 0){ tempMinutes = []}
        if(checkDuplicate(tempDaysOfMonth)){Message.push(<div key="tempDaysOfMonth1" className="alert alert-danger col-md-12"><strong>DaysOfMonth Contain</strong> a duplicate value</div>)}
        if(checkOutOfBounds(tempDaysOfMonth, 31)){Message.push(<div key="tempDaysOfMonth2" className="alert alert-danger col-md-12"><strong>DaysOfMonth</strong> has an out of bounds variable</div>)}
        if(checkDuplicate(tempDaysOfWeek)){Message.push(<div key="tempDaysOfWeek1" className="alert alert-danger col-md-12"><strong>DaysOfWeek</strong> Contain a duplicate value</div>)}
        if(checkOutOfBounds(tempDaysOfWeek, 7)){Message.push(<div key="tempDaysOfWeek2" className="alert alert-danger col-md-12"><strong>DaysOfMonth</strong> has an out of bounds variable</div>)}
        if(checkDuplicate(tempHours)){Message.push(<div key="tempHours1" className="alert alert-danger col-md-12"><strong>Hours</strong> Contain a duplicate value</div>)}
        if(checkOutOfBounds(tempHours, 24)){Message.push(<div key="tempHours2" className="alert alert-danger col-md-12"><strong>Hours</strong> has an out of bounds variable</div>)}
        if(checkDuplicate(tempMinutes)){Message.push(<div key="tempMinutes1" className="alert alert-danger col-md-12"><strong>Minutes</strong> Contain a duplicate value</div>)}
        if(checkOutOfBounds(tempMinutes, 60)){Message.push(<div key="tempMinutes2" className="alert alert-danger col-md-12"><strong>Minutes</strong> has an out of bounds variable</div>)}
        if(checkDuplicate(tempMonths)){Message.push(<div key="tempMonths1" className="alert alert-danger col-md-12"><strong>Months</strong> Contain a duplicate value</div>)}
        if(checkOutOfBounds(tempMonths, 12)){Message.push(<div key="tempMonths2" className="alert alert-danger col-md-12"><strong>Months</strong> has an out of bounds variable</div>)}
        if(tempDaysOfMonth.length > 0 && tempDaysOfWeek.length > 0){Message.push(<div key="errorMonth" className="alert alert-danger col-md-12"><strong>Days of Month</strong> and <strong>Days of Week</strong> can't both have a value</div>)}
        console.log(this.state);
        return Message;
    }
    
}

function checkOutOfBounds(array, max){
    for(let index in array){
        if(array[index] > max){
            return true;
        }
    }
    return false;
}

function checkDuplicate(array){
    return (new Set(array)).size !== array.length
}

function stringConstructor(timestamp, months, daysOfMonth, daysOfWeek, hours, minutes){
    let returner = "&";
    returner += "nextEventTimestamp="+ timestamp + "&";
    returner += "months="+ months + "&";
    returner += "daysOfMonth="+ daysOfMonth + "&";
    returner += "daysOfWeek="+ daysOfWeek + "&";
    returner += "hours="+ hours + "&";
    returner += "minutes="+ minutes;
    return returner;
}

function generateDayArray(datestring){
    let dateArray = datestring.split(',');
    let returnArray = [false, false, false, false, false, false, false];
    for(let index in dateArray){
        if(dateArray[index] !== null){
            returnArray[dateArray[index] - 1] = true;
        }
    }
    return returnArray;
}


// WEBPACK FOOTER //
// ./src/utils/editSchedule.js